import { useCallback } from 'react';
import { useAppSelector } from '../../store/hooks';
import { stockPartRequestBulkSelector } from '../../store/selectors/stockBulkSelector';
import { BIG_TABLES_PAGE_SIZES } from '../../core/utils/regex';
import { useBulkFilter } from './useBulkFilter';

interface PagingProps {
  currentPage?: number;
  pageSize?: number;
  totalItems: number;
  pageSizeOptions?: string[];
  onChange: (page: number, pageSize: number) => void;
}

export const useBulkPaging = (): PagingProps => {
  const [filter, setFilter] = useBulkFilter();
  const listData = useAppSelector(stockPartRequestBulkSelector);

  const handlePagingChange = useCallback((page: number, pageSize: number) => {
    setFilter((filter) => ({ ...filter, page, pageSize }));
  }, [setFilter]);

  return {
    onChange: handlePagingChange,
    currentPage: filter.page,
    pageSize: filter.pageSize,
    totalItems: listData.totalCount,
    pageSizeOptions: BIG_TABLES_PAGE_SIZES,
  };
};
